import React from "react";
import PropTypes from "prop-types";
import { Button } from "devextreme-react";

class FormButtons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { handleNext, handleBack, disableNext, customText } = this.props;

    return (
      <div className="cotizaciones-form-buttons">
        <Button
          key="step1"
          text="Anterior"
          className="next-button"
          onClick={handleBack}
          useSubmitBehavior
        />

        <Button
          key="step2"
          text={customText || "Siguiente"}
          type="success"
          className="next-button"
          onClick={handleNext}
          useSubmitBehavior
          disabled={disableNext}
        />
      </div>
    );
  }
}

FormButtons.propTypes = {
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  disableNext: PropTypes.bool,
};

export default FormButtons;
